import React, { useState } from "react";
import ModalOverlay from "../ModalOverlay/ModalOverlay";
import logoOrangeIcon from "../../assets/logo-orange.svg";
import qrCodeImage from "../../assets/images/qr_code_popover.png";
import communityPopoverHero from "../../assets/images/community_popover_hero.png";
import postPopoverHero from "../../assets/images/post_popover_hero.png";
import "./ComingSoonPopover.css";

type FeatureType = 'community' | 'post';

interface Props {
  onClose: () => void;
  featureType: FeatureType;
}

const FEATURE_CONTENT = {
  community: {
    heroImage: communityPopoverHero,
    heroAlt: "Globe Thrivers Community",
    title: "Join the Globe Thrivers community on mobile!",
    description: "We're building a better web experience, but for now you can connect, ask questions, and chat in the app.",
    qrTitle: "Ready to unlock the full potential of GT?",
    qrDescription: "Scan the QR code to download and start chatting & exploring."
  },
  post: {
    heroImage: postPopoverHero,
    heroAlt: "Post your travel content",
    title: "Post your travel content in the GT app",
    description: "We're still building this feature for web, but you can already share tips, photos, inspo, and hidden gems in the app. You can also create wishlists, save favorite spots, and build and share itineraries, in one place.",
    qrTitle: "Ready to unlock the full potential of GT?",
    qrDescription: "Scan the QR code to download and start chatting & exploring."
  }
};

const ComingSoonPopover: React.FC<Props> = ({ onClose, featureType }) => {
  const [isClosing, setIsClosing] = useState(false);
  const content = FEATURE_CONTENT[featureType];

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      onClose();
    }, 150);
  };

  return (
    <ModalOverlay onClose={handleClose} isClosing={isClosing} animate={true}>
      <div className={`coming-soon-popover ${isClosing ? 'closing' : ''}`} onClick={handleClose}>
        <button className="coming-soon-popover-close" onClick={handleClose} aria-label="Close">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        {/* Hero Image Section */}
        <div className="coming-soon-popover-hero">
          <img
            src={content.heroImage}
            alt={content.heroAlt}
            className="coming-soon-popover-hero-image"
          />
          <div className="coming-soon-popover-gradient"></div>
          <div className="coming-soon-popover-logo-overlay">
            <img src={logoOrangeIcon} alt="Globe Thrivers" className="coming-soon-popover-logo" />
          </div>
        </div>

        {/* Content Section */}
        <div className="coming-soon-popover-content">
          <div className="coming-soon-popover-coming-soon">Coming Soon on Web</div>

          <h2 className="coming-soon-popover-title">
            {content.title}
          </h2>

          <p className="coming-soon-popover-description">
            {content.description}
          </p>

          <div className="coming-soon-popover-divider coming-soon-popover-divider--desktop"></div>

          {/* QR Code Section - Desktop Only */}
          <div className="coming-soon-popover-qr-section">
            <div className="coming-soon-popover-qr-text">
              <strong>{content.qrTitle}</strong>
              <p>{content.qrDescription}</p>
            </div>
            <div className="coming-soon-popover-qr-code">
              <img src={qrCodeImage} alt="QR Code" className="qr-code-image" />
            </div>
          </div>
        </div>
      </div>
    </ModalOverlay>
  );
};

export default ComingSoonPopover;
